import React from 'react';
import { Button, Card, Typography, Space, Image } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/shared/lib/auth-context';
import caryLogo from '@/assets/cary-logo-black.png';
import { gtmAction } from '../utils/gtmaction';

const { Text } = Typography;

export const LoginPage: React.FC = () => {
  const { login, loading, isAuthenticated } = useAuth();
  const location = useLocation();
  const fromPathname = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname;

  // If already authenticated, redirect to intended page or dashboard
  if (isAuthenticated) {
    return <Navigate to={fromPathname || "/dashboard"} replace />;
  }

  const handleLogin = async () => {
    gtmAction('login-init');
    try {
      await login();
    } catch (error) {
      console.error('[LoginPage] Login error:', error);
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Card
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          width: 400,
          textAlign: 'center',
          border: 0,
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.1)',
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Image
            src={caryLogo}
            alt="Cary Logo"
            preview={false}
            style={{ height: 40, marginTop: 20 }}
          />
          <div>
            <Text type="secondary">
              Troubleshooting Guides Management
            </Text>
          </div>
          <Button
            type="primary"
            size="large"
            icon={<LoginOutlined />}
            onClick={handleLogin}
            loading={loading}
            style={{ width: '100%' }}
          >
            Sign in with Microsoft
          </Button>
        </Space>
      </Card>
    </div>
  );
};
